
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(148|164|584|745)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
